import { Button } from "antd";
import _ from "lodash";
import { OverlayPanel } from "primereact/overlaypanel";
import React, { useEffect, useRef, useState } from "react";

type Props = {
  key: string;
  disabled: boolean;
  value: any;
  onChange: (value: any) => void;
};

const DayPickerComponent = ({ key, value, onChange, disabled }: Props) => {
  const [selectedValue, setSelectedValue] = useState<any[]>(value);
  const op = useRef<any>(null);

  useEffect(() => {
    console.log(selectedValue);
    console.log(value);

    if (!_.isEqual(selectedValue, value)) {
      onChange(selectedValue);
    }
  }, [selectedValue]);

  const GetDateList = () => {
    let list: any[] = [];
    for (let i = 1; i <= 31; i++) {
      list.push({ name: i, value: i });
    }
    return list;
  };
  const dateList = GetDateList();

  return (
    <>
      <div
        key={key}
        className="p-inputtext p-component p-filled set-input-component-css"
        style={{ width: "100%", cursor: disabled ? "default" : "pointer" }}
        onClick={(e) => {
          !disabled && op.current.toggle(e);
        }}
      >
        {selectedValue.join(",")}
      </div>

      <OverlayPanel ref={op}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "50px 50px 50px 50px 50px 50px 50px",
            gap: 10,
          }}
        >
          {dateList.map((e) => {
            const dd = selectedValue.includes(e.value);
            return (
              <Button
                shape="round"
                size={"middle"}
                style={{ background: dd ? "#f8a51c" : "none" }}
                type="text"
                onClick={() => {
                  let arr: any[] = [...selectedValue];
                  if (arr.includes(e.value)) {
                    arr = arr.filter((sel) => sel !== e.value);
                  } else {
                    arr.push(e.value);
                  }
                  setSelectedValue([...arr]);
                }}
              >
                {e.name}
              </Button>
            );
          })}
        </div>
      </OverlayPanel>
    </>
  );
};

export default DayPickerComponent;
